import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const ListContent = styled.div`
	padding: 8px 0;
	margin: 0;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: relative;
	justify-content: flex-start;
`;

export const ListInfo = styled.div<{ disabled?: boolean }>`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-left: ${token.spacing4};
	margin-right: ${token.spacing4};
	${(props) => props.disabled && `color: ${token.gray500};`}
`;

export const ListTitle = styled.div`
	width: 100%;
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: ${token.gray800};
`;

export const ListSecondary = styled(ListTitle)`
	font-size: 14px;
	color: ${token.gray500};
`;

export const ListAction = styled.div`
	display: flex;
	align-items: 'center';
	margin-left: auto;
`;
export const Divider = styled.hr`
	height: 1px;
	margin: ${token.spacing3} 0;
	border: 0;
	background-color: ${token.gray50};
`;
